import React, { Component, Suspense } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import instance from "../../../../store/actions/instance";
import moment from "moment";

// Antd Components
import { Modal, Spin, Tabs, Button, message } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

//Actions
import {
  createPromotion,
  editSmartPromotion,
  fetchPromotions,
} from "../../../../store/actions";
import {
  getDiscountsText,
  serializeCategoryConditionDiscount,
  serializeModifierstDiscount,
  serializeProductsPercentDiscount,
} from "./Helpers";

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

//MyComponent
const ConditionsDiscountsTab = React.lazy(
  () => import("./ConditionsDiscountsTab"),
);
const GeneralSettingsTab = React.lazy(() => import("./GeneralSettingsTab"));
const PromotionAvailabilityTab = React.lazy(
  () => import("./PromotionAvailabilityTab"),
);

const TargetingTab = React.lazy(() => import("./TargetingTab"));
const { TabPane } = Tabs;

function isEmpty(obj) {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      return false;
    }
  }

  return JSON.stringify(obj) === JSON.stringify({});
}

const getEditedPromotionConditions = (conditions, couponCode) => {
  const newConditions = {};
  conditions.forEach((condition) => {
    if (condition.type === "products") {
      let productsConditionList = newConditions[condition.type] || [];

      productsConditionList.push({
        id: condition.id,
        type: "original",
        conditionID: condition.id,
        value: condition.value,
        products: condition.products,
      });
      newConditions[condition.type] = productsConditionList;
    } else if (["category_number", "category_value"].includes(condition.type)) {
      let categoriesConditionList = newConditions[condition.type] || [];
      categoriesConditionList.push({
        id: condition.id,
        type: "original",
        conditionID: condition.id,
        value: condition.value,
        categories: condition.categories,
      });
      newConditions[condition.type] = categoriesConditionList;
    } else {
      newConditions[condition.type] = {
        type: "original",
        conditionID: condition.id,
        value:
          (condition.type === "coupon" && couponCode) ||
          (["card_scheme", "card_bank"].includes(condition.type) &&
            condition.value_string) ||
          condition.value,
      };
    }
  });

  return newConditions;
};
const getEditedPromotionDiscounts = (discounts) => {
  const newDiscounts = {};
  discounts.forEach((discount) => {
    const discountType = discount.type;
    const discountValue = discount.value;

    if (discountType === "products") {
      let productList = newDiscounts.products || [];

      productList.push({
        id: discount.products[0].product_id,
        name: discount.products[0].name,
        ar_name: discount.products[0].ar_name,
        quantity: discount.products[0].quantity,
        originalValue: discount.products[0].quantity,
        type: "original",
        discountID: discount.id,
      });
      newDiscounts[discountType] = productList;
    } else if (discountType.startsWith("category")) {
      let categoriesDiscountList = newDiscounts[discountType] || [];
      categoriesDiscountList.push({
        id: discount.id,
        type: "original",
        discountID: discount.id,
        value: discountValue,
        categories: discount.categories,
      });
      newDiscounts[discountType] = categoriesDiscountList;
    } else if (discountType === "products_percent") {
      let productsDiscountList = newDiscounts[discountType] || [];
      productsDiscountList.push({
        id: discount.id,
        type: "original",
        discountID: discount.id,
        value: discountValue,
        products: discount.products,
      });
      newDiscounts[discountType] = productsDiscountList;
    } else if (discountType === "modifier") {
      let modifiersDiscountList = newDiscounts[discountType] || [];
      modifiersDiscountList.push({
        id: discount.id,
        type: "original",
        discountID: discount.id,
        value: discountValue,
        modifiers: discount.modifiers,
      });
      newDiscounts[discountType] = modifiersDiscountList;
    } else {
      newDiscounts[discountType] = {
        value: discount.value,
        originalValue: discount.value,
        type: "original",
        discountID: discount.id,
      };
    }
  });

  return newDiscounts;
};
class index extends Component {
  getInitialState = () => {
    const { editedPromotionIndex, promotions, pageNumber } = this.props;

    if (editedPromotionIndex !== null) {
      const editedPromotionObject =
        promotions[pageNumber][editedPromotionIndex];

      return {
        currentTab: "1",

        //conditionsTab
        conditions: getEditedPromotionConditions(
          editedPromotionObject.conditions,
          editedPromotionObject.code,
        ),
        discounts: getEditedPromotionDiscounts(editedPromotionObject.discounts),

        //GeneralSettingsTab
        name: editedPromotionObject.name,
        arabicName: editedPromotionObject.ar_name,
        description: editedPromotionObject.discount_description,
        arabicDescription: editedPromotionObject.ar_discount_description,
        quantity: editedPromotionObject.quantity,
        quantityPerUser: editedPromotionObject.quantity_per_user,
        maxDiscountAmount: editedPromotionObject.max_discount_amount,
        isLimited: editedPromotionObject.is_limited,
        showExpiry: editedPromotionObject.show_expiry,
        showRemaining: editedPromotionObject.show_remaining,
        backgroundColor: editedPromotionObject.background_color,
        applyOnlineOrders: editedPromotionObject.apply_to_online_orders,
        applyPOSOrders: editedPromotionObject.apply_to_pos_orders,
        autoApplyPOSOrders: editedPromotionObject.auto_apply_pos_orders,
        autoAddFreeProducts: editedPromotionObject.auto_add_free_products,
        expiredMessage: editedPromotionObject.expired_message,
        expiredMessageAR: editedPromotionObject.expired_message_ar,
        allowOrdersOutsidePeriod:
          editedPromotionObject.allow_orders_outside_period,

        applyForCash: editedPromotionObject.apply_for_cash,
        externalID: editedPromotionObject.external_id,

        isActive: editedPromotionObject.is_active,
        isPrivate: editedPromotionObject.is_private,
        startDate: moment(editedPromotionObject.start),
        expiryDate: moment(editedPromotionObject.expiry),
        banner: {
          name: "original",
          type: "original",
          image: editedPromotionObject.banner,
        },
        saveLoading: false,
        repeatable: editedPromotionObject.repeatable,
        maximumNumberOfRepetitions:
          editedPromotionObject.maximum_number_of_repetitions,
        hidePromotion: editedPromotionObject.hide_promotion,
        bypassMinimum: editedPromotionObject.bypass_minimum_order,
        exclusiveIn: editedPromotionObject.exclusive_in,

        //Availability
        availability: editedPromotionObject.availability.map((av) => {
          return { ...av, aid: av.id, type: "original" };
        }),

        //Excluded Objects
        excludedProducts: editedPromotionObject.excluded_products.map(
          (p) => p.id,
        ),
        excludedCategories: editedPromotionObject.excluded_categories.map(
          (p) => p.id,
        ),
        excludedModifiers: editedPromotionObject.excluded_modifiers.map(
          (p) => p.id,
        ),

        selectedBranches: [...editedPromotionObject.available_in_branches],

        selectedUsers: [],
        targetedCustomers: "all",
        sendTargetedEmails: true,
        targetedEmailBody: "",

        bulkCreate: false,
        bulkCreateAmount: 2,

        isEditing: true,

        minQuantity:
          editedPromotionObject.quantity - editedPromotionObject.remaining,
      };
    }
    return {
      currentTab: "1",

      //conditionsTab
      conditions: {},
      discounts: {},

      //GeneralSettingsTab
      name: "",
      arabicName: "",
      description: "",
      arabicDescription: "",
      expiredMessage: "Code Expired",
      expiredMessageAR: "انتهت صلاحية الرمز",
      quantity: 1,
      quantityPerUser: null,
      maxDiscountAmount: null,
      isActive: true,
      isPrivate: true,
      startDate: moment().set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
      }),
      expiryDate: moment().add(10, "days").set({
        hour: 23,
        minute: 59,
        second: 0,
        millisecond: 0,
      }),
      banner: null,
      saveLoading: false,
      repeatable: false,
      maximumNumberOfRepetitions: 1,
      hidePromotion: false,
      bypassMinimum: false,
      isLimited: false,
      showExpiry: false,
      showRemaining: false,
      backgroundColor: "#FFFFFF",
      applyOnlineOrders: true,
      applyPOSOrders: false,
      autoApplyPOSOrders: true,
      autoAddFreeProducts: false,
      allowOrdersOutsidePeriod: true,
      applyForCash: true,
      externalID: null,

      //Availability
      availability: [],

      //Excluded Objects
      excludedProducts: [],
      excludedCategories: [],
      excludedModifiers: [],

      selectedBranches: [],
      exclusiveIn: null,

      selectedUsers: [],
      targetedCustomers: "all",
      sendTargetedEmails: true,
      targetedEmailBody: "",

      bulkCreate: false,
      bulkCreateAmount: 2,

      isEditing: false,
      minQuantity: 1,
    };
  };
  state = this.getInitialState();
  setStateIndex = (key, value, changeType) => {
    this.setState({ [key]: value });
  };
  handleNext = () => {
    const { currentTab, isEditing } = this.state;
    const { settings } = this.props;
    const socialAuthEnabled =
      settings.enable_social_auth && settings.enable_social_auth_staff;
    if (currentTab === "4") {
      this.createPromotion();
    } else {
      if (currentTab == "2" && (!socialAuthEnabled || isEditing)) {
        this.setState({ currentTab: (parseInt(currentTab) + 2).toString() });
      } else {
        this.setState({ currentTab: (parseInt(currentTab) + 1).toString() });
      }
    }
  };
  handleBack = () => {
    const { currentTab } = this.state;
    const { settings } = this.props;
    const socialAuthEnabled =
      settings.enable_social_auth && settings.enable_social_auth_staff;
    if (currentTab == "4" && !socialAuthEnabled) {
      this.setState({ currentTab: (parseInt(currentTab) - 2).toString() });
    } else if (currentTab !== "1") {
      this.setState({ currentTab: (parseInt(currentTab) - 1).toString() });
    }
  };

  createPromotion = async () => {
    const t = this.props.t;
    this.setState({ saveLoading: true });
    const {
      startDate,
      expiryDate,
      conditions,
      discounts,
      repeatable,
      isEditing,
      autoAddFreeProducts,
    } = this.state;

    let canBeRepeated =
      !conditions.points &&
      ["category_number", "category_value", "number", "products", "value"].some(
        (repeatableCondition) =>
          this.getNotDeletedConditions(conditions).includes(
            repeatableCondition,
          ),
      );

    let showAutoAddFreeProducts = ["products", "category_free"].some(
      (freeDiscount) =>
        this.getNotDeletedDiscounts(discounts).includes(freeDiscount),
    );
    const payload = {
      ...this.state,
      startDate: startDate.format("YYYY-MM-DD HH:mm"),
      expiryDate: expiryDate.format("YYYY-MM-DD HH:mm"),
      isSmartPromo: true,
      repeatable: (canBeRepeated && repeatable) || false,
      autoAddFreeProducts:
        (showAutoAddFreeProducts && autoAddFreeProducts) || false,
      editedPromotionIndex:
        this.props.promotions[this.props.pageNumber][
          this.props.editedPromotionIndex
        ]?.key,
      exclusiveInP: this.state.exclusiveIn,
    };

    try {
      let url = "/create_promotion/";
      if (isEditing) {
        url = "/edit_promotion/";
      }

      let res = await instance.post(url, payload);
      if (res.data.success == true) {
        if (
          this.state.bulkCreate &&
          this.state.isPrivate &&
          !!this.state.conditions.coupon
        ) {
          message.loading(t("Promotions are being created"), 3);
        } else {
          if (isEditing) {
            message.success(t("Promotion edited successfully"));
            this.props.editSmartPromotion(
              res.data.promotion,
              this.props.editedPromotionIndex,
            );
          } else {
            message.success(t("Promotion created successfully"));
            // this.props.createPromotion(res.data.promotion);
            this.props.fetchPromotions(
              this.props.t,
              this.props.pageNumber,
              this.props.pageSize,
              this.props.totalPages,
              this.props.filters,
            );
          }
        }
        this.props.onClose();
        this.setState({ saveLoading: false });
      }
    } catch (err) {
      if (err.response && err.response.status == 403) {
        message.error(t("AccessDeniedMessage"));
        this.props.onClose();
      } else message.error(t("SomethingWentWrong"));
      this.setState({ saveLoading: false });
    }
  };

  removeConditionDiscounts = ({ type, id, objectType }) => {
    const { isEditing } = this.state;
    let newObject =
      objectType === "conditions"
        ? this.state.conditions
        : this.state.discounts;

    // Can reduce this
    if (type === "products") {
      const productIndex = newObject.products.findIndex((p) => p.id === id);
      newObject.products[productIndex].type = "delete";
      if (!newObject.products.length) {
        delete newObject.products;
      }
    } else if (type === "category" || type === "category_free") {
      const categoryIndex = newObject[type].findIndex((c) => c.id === id);
      newObject[type][categoryIndex].type = "delete";
      if (!newObject[type].length) {
        delete newObject[type];
      }
    } else if (type == "category_number") {
      const categoryIndex = newObject.category_number.findIndex(
        (c) => c.id === id,
      );
      newObject.category_number[categoryIndex].type = "delete";
      if (!newObject.category_number.length) {
        delete newObject.category_number;
      }
    } else if (type == "category_value") {
      const categoryIndex = newObject.category_value.findIndex(
        (c) => c.id === id,
      );
      newObject.category_value[categoryIndex].type = "delete";
      if (!newObject.category_value.length) {
        delete newObject.category_value;
      }
    } else if (type == "products_percent") {
      const productIndex = newObject.products_percent.findIndex(
        (discount) => discount.id === id,
      );

      newObject.products_percent[productIndex].type = "delete";

      if (!newObject.products_percent.length) {
        delete newObject.products_percent;
      }
    } else if (type == "modifier") {
      const categoryIndex = newObject.modifier.findIndex((c) => c.id === id);
      newObject.modifier[categoryIndex].type = "delete";
      if (!newObject.modifier.length) {
        delete newObject.modifier;
      }
    } else {
      if (isEditing) {
        newObject[type] = { ...newObject[type], type: "delete" };
      } else {
        delete newObject[type];
      }
    }

    this.setState({
      [objectType === "conditions" ? "conditions" : "discounts"]: {
        ...newObject,
      },
    });
  };
  nextButtonDisabled = () => {
    const {
      currentTab,
      discounts,
      name,
      arabicName,
      selectedUsers,
      targetedCustomers,
    } = this.state;

    if (
      currentTab == "1" &&
      getDiscountsText(discounts, this.props).length <= 0
    )
      return true;
    if (
      currentTab == "3" &&
      targetedCustomers === "targeted" &&
      !selectedUsers.length
    )
      return true;
    else if (
      currentTab == "4" &&
      (name.trim() === "" || arabicName.trim() === "")
    )
      return true;

    return false;
  };
  SetDates = (start, expiry) => {
    this.setState({ startDate: start, expiryDate: expiry });
  };

  getNotDeletedConditions = (conditions) => {
    const notDeletedCondtions = [];
    [
      "category_number",
      "category_value",
      "number",
      "products",
      "value",
    ].forEach((type) => {
      if (
        (conditions?.[type]?.type && conditions[type]?.type !== "delete") ||
        (Array.isArray(conditions[type]) &&
          conditions[type]?.filter((cond) => cond.type !== "delete").length > 0)
      ) {
        notDeletedCondtions.push(type);
      }
    });
    return notDeletedCondtions;
  };

  getNotDeletedDiscounts = (discounts) => {
    const notDeletedDiscounts = [];
    ["products", "category_free"].forEach((type) => {
      if (
        (discounts?.[type]?.type && discounts[type]?.type !== "delete") ||
        (Array.isArray(discounts[type]) &&
          discounts[type]?.filter((cond) => cond.type !== "delete").length > 0)
      ) {
        notDeletedDiscounts.push(type);
      }
    });
    return notDeletedDiscounts;
  };
  render() {
    const { visible, config, t, settings } = this.props;
    const {
      currentTab,
      conditions,
      discounts,
      name,
      arabicName,
      description,
      arabicDescription,
      expiredMessage,
      expiredMessageAR,
      quantity,
      quantityPerUser,
      maxDiscountAmount,
      isLimited,
      isActive,
      isPrivate,
      startDate,
      expiryDate,
      banner,
      repeatable,
      maximumNumberOfRepetitions,
      saveLoading,
      availability,
      excludedProducts,
      excludedCategories,
      excludedModifiers,
      selectedUsers,
      targetedCustomers,
      sendTargetedEmails,
      targetedEmailBody,
      bulkCreate,
      bulkCreateAmount,
      selectedBranches,
      backgroundColor,
      isEditing,
      minQuantity,
      hidePromotion,
      bypassMinimum,
      applyOnlineOrders,
      applyPOSOrders,
      allowOrdersOutsidePeriod,
      autoApplyPOSOrders,
      autoAddFreeProducts,
      applyForCash,
      exclusiveIn,
      showExpiry,
      showRemaining,
      externalID,
    } = this.state;
    let showRepeatable =
      !conditions.points &&
      ["category_number", "category_value", "number", "products", "value"].some(
        (repeatableCondition) =>
          this.getNotDeletedConditions(conditions).includes(
            repeatableCondition,
          ),
      );
    let couponPromo = !!conditions.coupon;
    let showAutoAddFreeProducts = ["products", "category_free"].some(
      (freeDiscount) =>
        this.getNotDeletedDiscounts(discounts).includes(freeDiscount),
    );
    const socialAuthEnabled =
      settings.enable_social_auth && settings.enable_social_auth_staff;

    return (
      <Modal
        destroyOnClose
        style={{ top: 20 }}
        width={800}
        title={
          <div
            className="ant-modal-title"
            style={{
              textAlign: config.direction == "rtl" ? "right" : "left",
            }}
          >
            {t(`${isEditing ? "Edit" : "New"} Promotion`)}
          </div>
        }
        visible={visible}
        onCancel={() => {
          this.props.onClose();
        }}
        bodyStyle={{
          paddingTop: 0,
          width: "auto",
          padding: "0px 18px",
          textAlign: config.direction == "ltr" ? "left" : "right",
        }}
        footer={[
          <Button
            key="back"
            onClick={this.handleBack}
            disabled={currentTab === "1"}
          >
            {t("Back")}
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={saveLoading}
            onClick={this.handleNext}
            disabled={this.nextButtonDisabled()}
          >
            {t(
              `${
                currentTab === "4"
                  ? t(`${isEditing ? "Edit" : "New"} Promotion`)
                  : t("Next")
              }`,
            )}
          </Button>,
        ]}
      >
        <Tabs
          size={"large"}
          tabPosition={"top"}
          animated={false}
          onTabClick={(key) => this.setState({ currentTab: key })}
          activeKey={currentTab}
        >
          <TabPane tab={t("Conditions & Discounts")} key={"1"}>
            <Suspense
              fallback={
                <div className="my-4 text-center">
                  <Spin indicator={antIcon} />
                </div>
              }
            >
              <ConditionsDiscountsTab
                setStateIndex={this.setStateIndex}
                conditions={conditions}
                discounts={discounts}
                removeConditionDiscounts={this.removeConditionDiscounts}
              />
            </Suspense>
          </TabPane>
          <TabPane
            tab={t("Availability")}
            key={"2"}
            disabled={currentTab == "1" && isEmpty(discounts)}
          >
            <Suspense
              fallback={
                <div className="my-4 text-center">
                  <Spin indicator={antIcon} />
                </div>
              }
            >
              <PromotionAvailabilityTab
                availability={availability}
                exclusiveIn={exclusiveIn}
                setStateIndex={this.setStateIndex}
              />
            </Suspense>
          </TabPane>
          {socialAuthEnabled && !isEditing && (
            <TabPane
              tab={t("Targetting")}
              key={"3"}
              disabled={currentTab == "1" && isEmpty(discounts)}
            >
              <Suspense
                fallback={
                  <div className="my-4 text-center">
                    <Spin indicator={antIcon} />
                  </div>
                }
              >
                <TargetingTab
                  setStateIndex={this.setStateIndex}
                  selectedUsers={selectedUsers}
                  targetedCustomers={targetedCustomers}
                  sendTargetedEmails={sendTargetedEmails}
                  targetedEmailBody={targetedEmailBody}
                />
              </Suspense>
            </TabPane>
          )}
          <TabPane
            tab={t("Finalize Promotion")}
            key={"4"}
            disabled={
              (currentTab == "1" && isEmpty(discounts)) ||
              (currentTab == "3" &&
                targetedCustomers === "targeted" &&
                !selectedUsers.length)
            }
          >
            <Suspense
              fallback={
                <div className="my-4 text-center">
                  <Spin indicator={antIcon} />
                </div>
              }
            >
              <GeneralSettingsTab
                setStateIndex={this.setStateIndex}
                setDates={this.SetDates}
                name={name}
                arabicName={arabicName}
                description={description}
                arabicDescription={arabicDescription}
                expiredMessage={expiredMessage}
                expiredMessageAR={expiredMessageAR}
                quantity={quantity}
                quantityPerUser={quantityPerUser}
                maxDiscountAmount={maxDiscountAmount}
                isLimited={isLimited}
                showRemaining={showRemaining}
                showExpiry={showExpiry}
                isActive={isActive}
                isPrivate={isPrivate}
                startDate={startDate}
                expiryDate={expiryDate}
                banner={banner}
                repeatable={repeatable}
                maximumNumberOfRepetitions={maximumNumberOfRepetitions}
                showRepeatable={showRepeatable}
                showAutoAddFreeProducts={showAutoAddFreeProducts}
                saveLoading={saveLoading}
                excludedProducts={excludedProducts}
                excludedCategories={excludedCategories}
                excludedModifiers={excludedModifiers}
                selectedBranches={selectedBranches}
                bulkCreate={bulkCreate}
                bulkCreateAmount={bulkCreateAmount}
                couponPromo={couponPromo}
                backgroundColor={backgroundColor}
                isEditing={isEditing}
                minQuantity={minQuantity}
                hidePromotion={hidePromotion}
                bypassMinimum={bypassMinimum}
                applyOnlineOrders={applyOnlineOrders}
                applyPOSOrders={applyPOSOrders}
                allowOrdersOutsidePeriod={allowOrdersOutsidePeriod}
                autoApplyPOSOrders={autoApplyPOSOrders}
                autoAddFreeProducts={autoAddFreeProducts}
                applyForCash={applyForCash}
                externalID={externalID}
              />
            </Suspense>
          </TabPane>
        </Tabs>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    config: state.config,
    settings: state.auth.settings,
    promotions: state.promotions.promotions,
    pageNumber: state.promotions.pageNumber,
    pageSize: state.promotions.pageSize,
    totalPages: state.promotions.totalPages,
    filters: state.promotions.filters,
    allProducts: state.products.allProducts,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    createPromotion: (promotion) => dispatch(createPromotion(promotion, true)),
    editSmartPromotion: (promotion, index) =>
      dispatch(editSmartPromotion(promotion, index)),
    fetchPromotions: (t, pageNumber, pageSize, totalPages, filters) =>
      dispatch(
        fetchPromotions(true, t, pageNumber, pageSize, totalPages, filters),
      ),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withNamespaces()(index));
